import moment from 'moment'
import * as IsActive from '../../components/is_active'
import * as Types from './types'

export const FETCH_LEAD_TEXT = 'FETCH_LEAD_TEXT'
export const LEAD_TEXT = 'LEAD_TEXT'
export const SERVER_RESOURCE = '/lead-text'
export const PUT_LEAD_TEXT = 'PUT_LEAD_TEXT'
export const POST_LEAD_TEXT = 'POST_LEAD_TEXT'

export const LEAD_TEXT_STATUS_UPDATE = IsActive.updateStatusConstant(LEAD_TEXT)
export type LeadTextStatusChange = IsActive.StateChangeActionObject

export const initialLeadText: Types.LeadText = {
  community_partner_code: null,
  created: null,
  created_datetime: null,
  description: '',
  editor_state: null,
  end_date: null,
  end_datetime: null,
  is_active: true,
  start_date: moment(),
  start_datetime: moment(),
  styles: null,
  title: '',
  updated: null,
  updated_datetime: null,
}



// WEBPACK FOOTER //
// ./src/pages/lead-text/constants.ts